import { render, staticRenderFns } from "./VideoSectionComponent.vue?vue&type=template&id=523ae18a&scoped=true&"
import script from "./VideoSectionComponent.vue?vue&type=script&lang=ts&"
export * from "./VideoSectionComponent.vue?vue&type=script&lang=ts&"
import style0 from "./VideoSectionComponent.vue?vue&type=style&index=0&id=523ae18a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523ae18a",
  null
  
)

export default component.exports